import React from "react";
import { Link } from "react-router-dom";

const Copyright = () => {
  return (
    <>
      {" "}
      <div class="container-fluid copyright py-4">
        <div class="container">
          <div class="row g-4 align-items-center">
            <div class="col-md-6 text-center text-md-start mb-md-0">
              <span class="text-body">
                <Link to="/" href="#" class="border-bottom text-white">
                  © Steward Cars
                </Link>
                , All right reserved.
              </span>
            </div>
            <div class="col-md-6 text-center text-md-end text-body">
              Designed By{" "}
              <a
                class="border-bottom text-white"
                href="https://www.threedolts.co.ke"
                target="__blank"
              >
                Three dolts
              </a>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Copyright;
